import z from 'zod';
export const SUBSCRIPTION_BILLING_REASONS = [
    'subscription_create',
    'subscription_cycle',
    'subscription_update',
    'subscription_threshold',
    'manual',
    'upcoming',
    'unknown',
];
export const billingReasonValue = z.enum(SUBSCRIPTION_BILLING_REASONS);
export const createBillingReason = (value) => billingReasonValue.parse(value);
export function isAdditionalProductInvoiceBillingReason(billingReason) {
    return billingReason === 'manual';
}
export function isFirmCheckoutInvoiceBillingReason(billingReason) {
    return billingReason === 'manual';
}
export function isSubscriptionBillingReason(billingReason) {
    return billingReason === 'subscription_create'
        || billingReason === 'subscription_cycle'
        || billingReason === 'subscription_update'
        || billingReason === 'subscription_threshold';
}
// Manual invoices created against a Stripe subscription (e.g. test
// renewal simulation) must still sync as subscription invoices.
export function isAllowedSubscriptionInvoiceBillingReason(billingReason) {
    return isSubscriptionBillingReason(billingReason)
        || billingReason === 'manual';
}
// Manual invoices linked to a subscription (test renewal / ad-hoc
// charge) must still trigger the payment confirmation email.
export function isSubscriptionConfirmationBillingReason(billingReason) {
    return billingReason === 'subscription_create'
        || billingReason === 'subscription_cycle'
        || billingReason === 'subscription_update'
        || billingReason === 'manual';
}
//# sourceMappingURL=billing-reason.js.map